export default {"src":"/_next/static/media/req.df127a3d.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};